import { useMutation, useQuery, useQueryClient } from "react-query";
import { Connection, ConnectionForm } from "@arelia-types/connection";
import { http } from "./http";

export function useConnections(ops?: any) {
  return useQuery<Connection[]>({
    queryKey: [`/api/connections`],
    queryFn: () => http(`/api/connections`),
    ...ops
  });
}

export function useSaveConnection(ops?: any) {
  const queryClient = useQueryClient();

  return useMutation<any, unknown, { connection: string; values: ConnectionForm; }>({
    mutationFn: ({ connection, values }) => http(`/api/connections/${connection}`, { method: "POST", body: values }),
    onSuccess: (data: any) => {
      // update connections query data
      const updater: any = (conenctions: any[]) => conenctions.map(c => c.name === data.name ? data : c);
      queryClient.setQueryData(['/api/connections'], updater);
    },
    ...ops
  });
}

export function useDeleteConnectionMutation() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (name: string) => http(`/api/connections/${name}`, {
      method: 'DELETE'
    }),
    onSuccess: () => {
      queryClient.invalidateQueries(['/api/connections']);
    }
  });
}